const oneYear = 60 * 60 * 24 * 365 * 1000; // 1yr in ms
export const COOKIE_EXPIRATION_TIME = oneYear;
